import { useCallback } from 'react';
import { getSettingsRepository, type Settings } from '@/repositories';

export function useSettingsStorage() {
  const load = useCallback(async (): Promise<Settings> => {
    return getSettingsRepository().get();
  }, []);

  const save = useCallback(async (s: Settings) => {
    await getSettingsRepository().save(s);
  }, []);

  const subscribe = useCallback(async (cb: (s: Settings) => void) => {
    return getSettingsRepository().subscribe(cb);
  }, []);

  return { load, save, subscribe } as const;
}

export default useSettingsStorage;
